// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".download_panel_container[data-v-0d3943f5]{box-shadow:0 1px 3px rgba(0,0,0,.12),0 -1px 5px rgba(0,0,0,.24)}.section_title[data-v-0d3943f5]{font-size:18px;background-color:#187cc6;padding-left:24px;color:#fff;text-align:center}", ""]);
// Exports
module.exports = exports;
